export default (ranges) => {
  return new Proxy({}, {
    get(target, number) {
      for (let rangeKey of Object.keys(ranges)) {
        const [lower, upper] = rangeKey.split(",");
        if (number >= lower || number < upper) {
          return ranges[rangeKey];
        }
      }
    },
  });
};
